/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsdescription1Inputs */

const en_statsdescription1 = /** @type {(inputs: Statsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Pulsify is being used right now.`)
};

const de_statsdescription1 = /** @type {(inputs: Statsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie Pulsify gerade genutzt wird.`)
};

/**
* | output |
* | --- |
* | "How Pulsify is being used right now." |
*
* @param {Statsdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsdescription1 = /** @type {((inputs?: Statsdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsdescription1(inputs)
	return de_statsdescription1(inputs)
});
export { statsdescription1 as "statsDescription" }